import { Blockquote, Inset, Text } from "@radix-ui/themes";


export default function Y2024M10() {

  return (
    <>
      <div className="container py-5">
        <div className='row'>

          <div className='col-lg-4'>
            <Inset clip="padding-box" side="top" pb="current">
              <img
                src="https://www.shadvala.org/img/interstices-2024-10-01.jpg"
                alt="Events"
                style={{
                  display: 'block',
                  objectFit: 'cover',
                  width: '100%',
                  height: '100%',
                  backgroundColor: 'var(--gray-5)',
                }}
              />
              <Text as="p" mb="5" size="2">
                Photo by Adrián Navigante
              </Text>
            </Inset>
          </div>

          <div className='col-lg-8'>
            <div className="container">
              <div className='row py-3 border-top'>
                <div className='col'>
                  <Text as="p" mb="5" size="2" weight="bold">
                  11-13 October 2024, Labyrinth, Zagarolo (Italy)
                  </Text>
                </div>
              </div>
              <div className='row pb-3'>
                <div className='col'>
                  <Blockquote size="4" color>
                    Workshop: <i>Geo-philosophical Aspects of South Asian, Amerindian, and West-African Traditions</i>
                  </Blockquote>
                  <Blockquote size="2" color>
                    <b>Project Animism in Practice</b>
                  </Blockquote>
                  <Blockquote size="2" color>
                    Center Interstices in collaboration with FAD
                  </Blockquote>
                </div>
              </div> 
              <div className='row pb-3'>
                <div className='col'>
                  <Text as="p" mb="5" size="3">
                    The creation of a therapeutic space in traditional societies implies the restauration of a collective order through different types of intervention. This implies a broader and more complex form of socialization than modern parameters enable to think, especially if one takes into account the living field of relations emerging from such practices. This workshop is an exploration of that field, which de-centers the human to redress the earth-balance.
                  </Text>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </>
  )
}
